import React from "react"
import { connect } from "react-redux"
import { Redirect } from "react-router-dom"
import { APP_ROUTES } from "helpers/routeHelpers"
import { UserTypes } from "constants"
import { isUserInRoles } from "utils/commonUtils"
import { MANAGER_ROLES } from "constants"

export default Component => {
   class WithAuthentication extends React.Component {
      render() {
         const { isAuthenticated, user } = this.props

         if (isAuthenticated) {
            const redirectPath = isUserInRoles(user?.type, MANAGER_ROLES)
               ? APP_ROUTES.TIMELINE
               : APP_ROUTES.DASHBOARD

            return <Redirect to={redirectPath} />
         }

         return <Component {...this.props} />
      }
   }

   const mapStateToProps = state => ({
      isAuthenticated: state.userAuth.isAuthenticated,
      user: state.userAuth.user,
   })

   return connect(mapStateToProps)(WithAuthentication)
}
